export class Info {
    infoId: string;
    type: string;
    content: string;
    position: number;
    projectId: number;
    additionalData: string;
}
